import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_a0f4ef58/src/layouts/default.vue").then(m => m.default || m))
}